var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcons6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 7.80968V3.64801C20.1667 2.35551 19.58 1.83301 18.1225 1.83301H14.4192C12.9617 1.83301 12.375 2.35551 12.375 3.64801V7.80051C12.375 9.10217 12.9617 9.61551 14.4192 9.61551H18.1225C19.58 9.62467 20.1667 9.10218 20.1667 7.80968Z",
    stroke: "#15194B",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 18.1225V14.4192C20.1667 12.9617 19.58 12.375 18.1225 12.375H14.4192C12.9617 12.375 12.375 12.9617 12.375 14.4192V18.1225C12.375 19.58 12.9617 20.1667 14.4192 20.1667H18.1225C19.58 20.1667 20.1667 19.58 20.1667 18.1225Z",
    stroke: "#15194B",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 7.80968V3.64801C9.625 2.35551 9.03834 1.83301 7.58084 1.83301H3.8775C2.42 1.83301 1.83334 2.35551 1.83334 3.64801V7.80051C1.83334 9.10217 2.42 9.61551 3.8775 9.61551H7.58084C9.03834 9.62467 9.625 9.10218 9.625 7.80968Z",
    stroke: "#15194B",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 18.1225V14.4192C9.625 12.9617 9.03834 12.375 7.58084 12.375H3.8775C2.42 12.375 1.83334 12.9617 1.83334 14.4192V18.1225C1.83334 19.58 2.42 20.1667 3.8775 20.1667H7.58084C9.03834 20.1667 9.625 19.58 9.625 18.1225Z",
    stroke: "#15194B",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcons6);
export default __webpack_public_path__ + "static/media/menu-icons-6.50c78c2738254f936b7bf0a53ddf4820.svg";
export { ForwardRef as ReactComponent };